import { jsx as _jsx } from "react/jsx-runtime";
import { ComponentSync } from '../core/ComponentSync.js';
export class HeightBounder extends ComponentSync {
    ref;
    __onWindowResized() {
        this.forceUpdate();
    }
    deriveStateFromProps(nextProps) {
        return {};
    }
    render() {
        const ref = this.ref;
        let height = undefined;
        if (ref)
            height = `${window.innerHeight - ref.offsetTop - 3}px`;
        const tempProps = { ...this.props };
        delete tempProps.style;
        return _jsx("div", { ...tempProps, style: { ...this.props.style, height }, ref: ((_ref) => {
                if (this.ref)
                    return;
                this.ref = _ref;
                this.forceUpdate();
            }), children: this.props.children });
    }
}
//# sourceMappingURL=HeightBounder.js.map